import {findIndex, memoizeSimple} from "./framework/voidash";

const strings = {};

const isPluralizedString = string => string.length > 2 && string.slice(0, 2) === "**";

const getPluralizedStringRexExp = memoizeSimple(caseCnt => new RegExp(`\\*\\*\\|[a-zA-Z]+\\|(?:\\*[^*]*){${caseCnt}}\\*\\*`, "g"));

const findPluralForm = (pluralForm, count) => findIndex(pluralForm, ([l, u]) => count >= l && (u === "inf" || count <= u));

function pluralizeString(string, pluralForm, data) {
  // syntax: **neconeconeco **|pocet|*prvni*druhy*treti*ctvrty*...**

  string = string.slice(2);
  const re = getPluralizedStringRexExp(pluralForm.length);
  return string.replace(re, s => {
    const arr = s.split("*");
    const key = arr[2].slice(1, -1); // remove |...|
    const cnt = +data[key] || 0;
    const idx = findPluralForm(pluralForm, cnt);
    return arr[idx + 3];
  });
}

const variableRE = /\|([a-zA-Z]+)\|/g;

export default {
  pluralForm: [[0, "inf"]], // format: [[0,0],[1,1],[2,4],[5,"inf"]]; takze pro 0 az 0 se bere prvni, 1-1 druhy, 2-4 treti a 5-inf ctvrty

  add(key, string) {
    strings[key] = string;
  },

  translate(key, data) {
    let string = strings[key];

    if (!string) return key;

    if (isPluralizedString(string)) {
      string = pluralizeString(string, this.pluralForm, data);
    }

    return string.replace(variableRE, (str, key) => data[key] || "");
  }
};
